<template>
    <div>
        <div v-if="!isVoucher">
            <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
                <el-tab-pane label="收信列表" name="first">
                    <el-tabs v-model="readName" @tab-click="handleReadClick">
                        <el-tab-pane label="未读" name="unread">
                        </el-tab-pane>
                        <el-tab-pane label="已读" name="read">
                        </el-tab-pane>
                        <swb-receiver-msg-list :readFlag="readFlag"></swb-receiver-msg-list>
                    </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="发信列表" name="second">
                    <swb-send-msg-list :senderId="myReceiverId"></swb-send-msg-list>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-if="isVoucher">
            <swb-send-msg-list :isVoucher="isVoucher" :group="group" :fieldx="fieldx" :fieldy="fieldy" :receiverData="receiverData"></swb-send-msg-list>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base';
    import { Vue, MsgBox, Routes } from '../../app.vues';

    import ReceiverMsgList from './ReceiverMsgList';
    Vue.regist(ReceiverMsgList);

    import SendMsgList from './SendMsgList';
    Vue.regist(SendMsgList);

    export default{
        name: 'swb-msg-list',
        desc: '站内信列表',
        props: {
            refreshUnreadMsgCount: {
                type: Function
            },
            isVoucher: {
                type: Boolean,
                default: false
            },
            group: {
                type: String
            },
            fieldx: {
                type: String
            },
            fieldy: {
                type: String
            },
            receiverData: {}
        },
        data: function () {
            return {
                activeName: 'first',
                myReceiverId: null,
                readName: 'unread',
                readFlag: false,
            }
        },
        created: function () {
            this.myReceiverId = MsgClient.getReceiverId();
        },
        methods: {
            handleClick(tab, event) {
                console.log();
            },
            handleReadClick(tab, event){
                if(this.readName == "unread") {
                    this.readFlag = false;
                } else {
                    this.readFlag = true;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/MsgList.vue